module.exports = __webpack_public_path__ + "static/img/logo.72521bc3.svg";